import React, { useState } from "react";
import { Button, Checkbox, Popover } from "antd";
import { SettingOutlined } from "@ant-design/icons";

const readHidden = (storageKey, defaults) => {
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey));
    return Array.isArray(saved) ? saved : defaults;
  } catch {
    return defaults;
  }
};

// Show/hide table columns by title, remembered per table in this browser.
// Columns without a string title, or listed in alwaysShown, always show.
const useColumnPicker = (
  storageKey,
  columns,
  hiddenByDefault = [],
  alwaysShown = [],
) => {
  const [hidden, setHidden] = useState(() =>
    readHidden(storageKey, hiddenByDefault),
  );

  const updateHidden = (next) => {
    setHidden(next);
    try {
      localStorage.setItem(storageKey, JSON.stringify(next));
    } catch {
      // private window / blocked storage: keep it for this session only
    }
  };

  const titles = columns
    .map((column) => column.title)
    .filter(
      (title) =>
        typeof title === "string" && title && !alwaysShown.includes(title),
    );
  const visibleColumns = columns.filter(
    (column) => !hidden.includes(column.title),
  );

  const picker = (
    <Popover
      trigger="click"
      placement="bottomRight"
      content={
        <Checkbox.Group
          className="flex flex-col gap-1"
          options={titles}
          value={titles.filter((title) => !hidden.includes(title))}
          onChange={(shown) =>
            updateHidden(titles.filter((title) => !shown.includes(title)))
          }
        />
      }
    >
      <Button size="small" icon={<SettingOutlined />}>
        Columns
      </Button>
    </Popover>
  );

  return { visibleColumns, picker };
};

export default useColumnPicker;
